<template>
  <div class='check-box'>
    <custom-checkbox
      color="cold-marine"
      :value="value"
      size="s"
      @input="value = !value"
    >
    </custom-checkbox>
  </div>
</template>

<script>
import CustomCheckbox from '@/components/common/CustomCheckbox.vue';

export default {
  name: 'CheckBoxTableCell',
  components: {
    CustomCheckbox,
  },
  props: {
    selectedItems: {
      type: Array,
      required: true,
      default: () => [],
    },
    excludedItems: {
      type: Array,
      required: true,
      default: () => [],
    },
    isAllSelected: {
      type: Boolean,
      required: true,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    value: {
      // eslint-disable-next-line no-unused-vars
      set(value) {
        this.$emit('checked', this.item);
      },
      get() {
        return this.selectedItems.includes(this.item.url) ||
          (this.isAllSelected && this.item?.selected !== undefined && this.item.selected && !this.excludedItems.includes(this.item.url)) ||
          (this.isAllSelected && this.item?.selected === undefined && !this.excludedItems.includes(this.item.url));
      },
    },
  },
};
</script>

<style lang='scss'>
.bucket-select {
  min-width: 35px !important;
}
</style>
<style lang="scss" scoped>
.checkbox-container {
  margin-top: 21px;
}
.check-box {
  margin-top: -2px;
}
</style>
